import React from 'react';

const Tent = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 24.595C3.438 24.595 0 29.259 0 31.415C0 33.571 1.791 35.415 4 35.415H32C34.209 35.415 36 33.564 36 31.415C36 29.266 32.562 24.595 18 24.595Z"
        fill="#78B159"
      />
      <path
        d="M28.8041 27.565C28.8041 29.096 27.5621 29.645 26.0311 29.645C24.5001 29.645 23.2581 29.097 23.2581 27.565L23.9511 21.326C23.9511 19.795 24.4991 19.939 26.0311 19.939C27.5621 19.939 28.1111 19.794 28.1111 21.326L28.8041 27.565Z"
        fill="#662113"
      />
      <path
        d="M34.8681 19.132C30.2781 14.997 28.4191 9.07599 26.0311 9.07599C23.6431 9.07599 21.7841 14.997 17.1951 19.132C15.2661 20.87 16.1851 21.875 18.8291 21.674C21.1861 21.495 23.3901 20.933 26.0311 20.933C28.6721 20.933 30.8771 21.496 33.2331 21.674C35.8771 21.875 36.7961 20.869 34.8681 19.132Z"
        fill="#5C913B"
      />
      <path
        d="M33.3771 17.493C29.8501 14.092 27.8681 9.21997 26.0311 9.21997C24.1951 9.21997 22.2131 14.092 18.6861 17.493C15.8831 20.196 22.3591 20.802 26.0311 17.493C29.7021 20.802 36.1791 20.196 33.3771 17.493Z"
        fill="#3E721D"
      />
      <path
        d="M33.3771 14.738C29.8501 11.56 27.8681 7.00897 26.0311 7.00897C24.1951 7.00897 22.2131 11.56 18.6861 14.738C15.8831 17.263 22.3591 17.829 26.0311 14.738C29.7021 17.829 36.1791 17.262 33.3771 14.738Z"
        fill="#5C913B"
      />
      <path
        d="M31.766 12.481C29.013 10 27.465 6.44702 26.031 6.44702C24.598 6.44702 23.05 10 20.296 12.481C18.108 14.452 23.163 14.895 26.031 12.481C28.898 14.894 33.954 14.452 31.766 12.481Z"
        fill="#3E721D"
      />
      <path
        d="M31.766 10.416C29.013 7.93502 27.465 4.38202 26.031 4.38202C24.598 4.38202 23.05 7.93502 20.296 10.416C18.108 12.387 23.163 12.83 26.031 10.416C28.898 12.83 33.954 12.388 31.766 10.416Z"
        fill="#5C913B"
      />
      <path
        d="M30.6589 8.58299C28.4369 6.58099 27.1879 3.71399 26.0309 3.71399C24.8739 3.71399 23.6249 6.58099 21.4029 8.58299C19.6369 10.174 23.7169 10.531 26.0309 8.58299C28.3449 10.531 32.4259 10.174 30.6589 8.58299Z"
        fill="#3E721D"
      />
      <path
        d="M30.6589 7.02897C28.4369 5.02697 27.1879 2.15997 26.0309 2.15997C24.8739 2.15997 23.6249 5.02697 21.4029 7.02897C19.6369 8.61997 23.7169 8.97697 26.0309 7.02897C28.3449 8.97697 32.4259 8.61997 30.6589 7.02897Z"
        fill="#5C913B"
      />
      <path
        d="M29.5531 4.74101C27.8631 3.21801 26.9121 1.03601 26.0311 1.03601C25.1511 1.03601 24.2001 3.21801 22.5091 4.74101C21.1651 5.95201 24.2701 6.22301 26.0311 4.74101C27.7921 6.22401 30.8971 5.95201 29.5531 4.74101Z"
        fill="#3E721D"
      />
      <path
        d="M29.5531 3.705C27.8631 2.182 26.9121 0 26.0311 0C25.1511 0 24.2001 2.182 22.5091 3.705C21.1651 4.916 24.2701 5.187 26.0311 3.705C27.7921 5.187 30.8971 4.916 29.5531 3.705Z"
        fill="#5C913B"
      />
      <path
        d="M15.1009 32.415C14.6769 32.415 14.2989 32.148 14.1569 31.749L9.14494 17.716C9.03494 17.409 9.08194 17.088 9.26994 16.82C9.45794 16.555 9.76393 16.415 10.0899 16.415H21.8489C22.2499 16.415 22.6129 16.635 22.7709 17.004L28.7849 31.027C28.9179 31.337 28.8859 31.688 28.7009 31.969C28.5129 32.251 28.1989 32.415 27.8619 32.415H15.1009Z"
        fill="#F4900C"
      />
      <path
        d="M4.07502 32.415C3.73802 32.415 3.42302 32.245 3.23802 31.965C3.05302 31.683 3.02202 31.327 3.15402 31.017L9.17202 16.975C9.32902 16.607 9.69302 16.368 10.093 16.368C10.494 16.368 10.858 16.608 11.015 16.975L17.033 31.016C17.166 31.327 17.133 31.682 16.948 31.964C16.763 32.245 16.448 32.415 16.111 32.415H4.07502Z"
        fill="#FFCC4D"
      />
      <path
        d="M10.09 18.851L8.08398 32.415H12.094L10.09 18.851Z"
        fill="#292F33"
      />
      <path
        d="M14.127 31.302L14.575 32.415H12.094L14.127 31.302ZM6.052 31.302L5.604 32.415H8.084L6.052 31.302Z"
        fill="#FFAC33"
      />
      <path
        d="M12.0941 32.415C12.0941 32.415 13.9171 31.95 14.8081 31.127L10.0901 18.851L12.0941 32.415ZM8.08412 32.415C8.08412 32.415 6.26112 31.95 5.37012 31.127L10.0891 18.85L8.08412 32.415Z"
        fill="#FFE8B6"
      />
      <path
        d="M13.625 5.04C13.607 5.04 13.591 5.046 13.573 5.046C13.607 4.882 13.625 4.713 13.625 4.539C13.625 3.158 12.506 2.039 11.125 2.039C10.234 2.039 9.458 2.508 9.015 3.21C8.738 3.104 8.44 3.04 8.125 3.04C6.85 3.04 5.81 3.997 5.656 5.23C5.374 5.117 5.073 5.04 4.75 5.04C3.369 5.04 2.25 6.159 2.25 7.54C2.25 8.921 3.369 10.04 4.75 10.04H13.625C15.006 10.04 16.125 8.921 16.125 7.54C16.125 6.159 15.006 5.04 13.625 5.04Z"
        fill="#E1E8ED"
      />
    </svg>
  );
};

export default Tent;
